import styled from 'styled-components';

import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { rem } from 'approot/shared/style';
import { spacing24, spacing40 } from 'approot/shared/styles/spacing.style';
import {
  font20,
  font24,
  font30,
  fontSize38,
  fontSize38LineHeight,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import {
  grey7,
  grey8,
  grey9,
  purple1,
  purple8,
} from 'approot/shared/styles/colours.style';
import {
  SubActivityInstruction,
  SubActivityLabel,
} from '../sub-activity/sub-activity-view.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const MultipleChoiceCheckAnswer = styled.div`
  ${flexCentreAlignCss}
  margin-top: ${rem(spacing24)};
`;

type MultipleChoiceCheckAnswerQuestionProps = {
  $noMarginBottom?: boolean;
};
export const MultipleChoiceCheckAnswerQuestion = styled.div<MultipleChoiceCheckAnswerQuestionProps>`
  ${SubActivityInstruction} {
    margin-bottom: ${({ $noMarginBottom }) =>
      $noMarginBottom ? 0 : rem(spacing24)};
  }

  ${SubActivityInstruction} p, ${SubActivityLabel} {
    font-size: ${rem(fontSize38)};
    line-height: ${rem(fontSize38LineHeight)};
    margin-bottom: 0;
  }
`;

export const MultipleChoiceCheckAnswerText = styled.div`
  ${font24}
  color: ${grey7};
  margin-bottom: ${rem(spacing24)};
`;

export const MultipleChoiceCheckAnswerFeedback = styled.div`
  ${font30}
  color: ${grey9};
  font-weight: ${fontWeightMedium};
  margin-top: ${rem(spacing40)};
  text-align: center;
`;

export const MultipleChoiceMoreInfo = styled.div`
  ${font30}
  background-color: ${purple1};
  border-radius: ${rem(borderRadius8)};
  color: ${purple8};
  margin-top: ${rem(spacing24)};
  padding: ${rem(spacing24)};
`;

export const MultipleChoiceFreeAnswerText = styled.p`
  ${font20}
  color: ${grey8};
  margin-top: ${rem(spacing40)};
  margin-bottom: 0;
  text-align: center;
`;
